import { API_URL } from "../Config/config";
import { fetchApiData } from "../Helper/helper";


/**
 * @description returns data of seller for open or closed market
 */
export const getSellerData = async (marketType = "open") => {
   const endpoint = marketType === "closed"
      ? `${API_URL}/seller/closed-market/dashboard-details`
      : `${API_URL}/seller/dashboardDetails`;
   const response = await fetchApiData(endpoint, {
      method: "GET",
      headers: {
         "Content-Type": "application/json",
      },
   });

   return response;
};
/**
 * @description returns data of seller
 */
export const getCreditDetailsData = async () => {
   const response = await fetchApiData(`${API_URL}/auth/subscriptions`, {
      method: "GET",
      headers: {
         "Content-Type": "application/json",
      },
   });

   return response;
};

/**
 * 
 * @returns user profile Data
 */
export const getUserProfile = async () => {
   const response = await fetchApiData(`${API_URL}/auth/user`, {
      method: "GET",
      headers: {
         "Content-Type": "application/json",
         authToken: localStorage.getItem("auth"),
      },
   });
   return response;
};


/**   
 * @description post image file for saving User profile picture 
 *  
 * */
export const postUserProfileImage = async (formData) => {
   const response = await fetchApiData(`${API_URL}/auth/profilePic`, {
      method: "POST",
      headers: {
         // "Content-Type": "multipart/form-data; boundary=<calculated when request is sent>",
      },
      body: formData,
   });

   return response;
}